export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M10 10a4 4 0 00-4-4 6 6 0 01-6-6h2a4 4 0 004 4 6 6 0 016 6 4 4 0 004 4 6 6 0 016 6 4 4 0 004 4v2a6 6 0 01-6-6 4 4 0 00-4-4 6 6 0 01-6-6zm25.5-2l8.5 8.5-1.5 1.4L34 9.5 35.5 8z\" clip-rule=\"evenodd\" opacity=\".2\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "52",
    "height": "26",
    "fill": "none",
    "viewBox": "0 0 52 26"
  }
};